import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'does_facility_charge_kind_benefits_below_cost'

export const dataPointDefinition = {
  retracedId: 'does_facility_charge_kind_benefits_below_cost',
  name: 'Does the facility charge for in-kind benefits at or below cost?',
  description:
    'The intent of this question is to understand if in-kind benefits are always provided for free or at the actual cost of goods. ',
  meta: {
    slcpMeta: {
      key: 'wb-22--4',
      number: 'WB-WAGE-145',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wb-22--4', version: '1.7.0', provider: 'slcp'}],
  sortingId: 35410,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
